import React from 'react';
import DuperbrowseStreamContextProvider from './DuperbrowseStreamContextProvider';
const LoadableDeviationDuperbrowseContext = ({ children , streamId , parent , isLoadMoreAllowed , streamItemSelector  })=>{
    return /*#__PURE__*/ React.createElement(DuperbrowseStreamContextProvider, {
        stream: {
            streamId,
            parent,
            enableLoader: isLoadMoreAllowed,
            streamItemSelector,
            itemSchema: 'deviation'
        }
    }, children);
};
LoadableDeviationDuperbrowseContext.displayName = 'LoadableDeviationDuperbrowseContext';
export default LoadableDeviationDuperbrowseContext;
